
import Maximize2 from "../../../assets/outline/Maximize2.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Maximize2Icon({ className, dataTestid = "Maximize2Icon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Maximize2 data-testid={dataTestid} className={classes} {...rest} />
  );
}
